import { render, staticRenderFns } from "./AssuntosCadastro.vue?vue&type=template&id=7972c130&"
import script from "./AssuntosCadastro.vue?vue&type=script&lang=js&"
export * from "./AssuntosCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports